export enum UserStatus {
    ANY = 'ANY',
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    TERMINATED = 'TERMINATED',
    PRELOAD = 'PRELOAD'
}


export enum TrainingStatus {
    ANY = 'ANY',
    PASSED = 'PASSED',
    FAILED = 'FAILED',
    INCOMPLETE = 'INCOMPLETE',
    NOTATTEMPTED = 'NOT ATTEMPTED'
}
